import React, { useState, useEffect, useCallback } from "react";
import { componenteService } from "../../services/componenteService";

const formatNumber = (num) => {
    return num.toLocaleString("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export default function ComponenteSimpleForm({ tipo, titulo }) {
    const [itemsGuardados, setItemsGuardados] = useState([]);
    const [nuevo, setNuevo] = useState({ nombre: "", costo: "" });
    const [total, setTotal] = useState(0);
    const [editingId, setEditingId] = useState(null);
    const [editingComponent, setEditingComponent] = useState(null);

    const cargar = useCallback(async () => {
        try {
            const data = await componenteService[tipo].getAll();
            setItemsGuardados(data || []);
        } catch (e) {
            console.error("Error cargando:", e);
        }
    }, [tipo]);

    useEffect(() => {
        cargar();
    }, [cargar]);

    useEffect(() => {
        let suma = itemsGuardados.reduce((acc, i) => acc + (i.costoTotal || i.costo || 0), 0);
        setTotal(suma);
    }, [itemsGuardados]);

    const guardar = async () => {
        if (!nuevo.nombre || !nuevo.costo) return;
        try {
            const tipoMap = {
                unidadCondensadora: "UnidadCondensadora",
                evaporadorCubico: "Forzador"
            };

            const payload = {
                ...(editingComponent || {}),
                type: tipoMap[tipo] || tipo,
                nombre: nuevo.nombre,
                costo: parseFloat(nuevo.costo)
            };

            if (editingId) {
                await componenteService[tipo].update(editingId, payload);
            } else {
                await componenteService[tipo].create(payload);
            }

            setEditingId(null);
            setEditingComponent(null);
            setNuevo({ nombre: "", costo: "" });
            await cargar();
        } catch (error) {
            console.error("Error al guardar:", error);
            alert(editingId ? "Error al actualizar el componente" : "Error al guardar");
        }
    };

    const editar = (item) => {
        setEditingId(item.id);
        setEditingComponent(item);
        setNuevo({
            nombre: item.nombre || "",
            costo: item.costo ?? item.costoTotal ?? "",
        });
    };

    const cancelarEdicion = () => {
        setEditingId(null);
        setEditingComponent(null);
        setNuevo({ nombre: "", costo: "" });
    };

    const eliminar = async (id) => {
        if (!window.confirm("¿Eliminar este componente?")) return;
        try {
            await componenteService[tipo].delete(id);
            cargar();
        } catch (error) {
            console.error("Error al eliminar:", error);
            alert("Error al eliminar");
        }
    };

    return (
        <div className="components-wrapper">
            <div className="components-container">
                <h2 className="title">Gestión de Componentes: {titulo}</h2>

                <div className="card">
                    <div className="grid">
                        <input
                            placeholder="Nombre"
                            value={nuevo.nombre}
                            onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })}
                        />
                        <input
                            placeholder="Costo"
                            type="number"
                            value={nuevo.costo}
                            onChange={(e) => setNuevo({ ...nuevo, costo: e.target.value })}
                        />
                    </div>

                    <button className="btn-save" onClick={guardar}>
                        {editingId ? `Guardar cambios de ${titulo}` : `Guardar ${titulo}`}
                    </button>
                    {editingId && (
                        <button type="button" className="btn-cancel" onClick={cancelarEdicion}>
                            Cancelar edición
                        </button>
                    )}
                </div>

                <h3 className="title">Items Guardados</h3>

                <table className="table">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Costo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemsGuardados.map((it, index) => (
                            <tr key={index}>
                                <td>{it.nombre}</td>
                                <td>${formatNumber(it.costoTotal || it.costo || 0)}</td>
                                <td>
                                    <button
                                        type="button"
                                        className="btn-edit"
                                        onClick={() => editar(it)}
                                    >
                                        ✏️ Editar
                                    </button>
                                    <button
                                        type="button"
                                        className="btn-delete"
                                        onClick={() => eliminar(it.id)}
                                    >
                                        ✕
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h2 className="total">✅ Total: ${formatNumber(total)} ARS</h2>
            </div>
        </div>
    );
}
